@if (text) {
  <mat-chip [ngClass]="chipClasses">
    <span [ngClass]="classes">
      {{ text | translate }}
    </span>
  </mat-chip>
}
